import { z } from 'zod';
/**
 * Nickname rules, shared by the client (input validation + button enabling) and
 * the server (authoritative check on POST /api/me/nickname). One source of truth
 * so the two can never disagree about what's acceptable.
 */
export const NICKNAME_MIN = 2;
export const NICKNAME_MAX = 16;
/** Letters, digits, spaces, and a few name-friendly punctuation marks. */
export const NICKNAME_PATTERN = /^[\p{L}\p{N} _.\-]+$/u;
export const NicknameSchema = z
    .string()
    .trim()
    .min(NICKNAME_MIN, `At least ${NICKNAME_MIN} characters`)
    .max(NICKNAME_MAX, `At most ${NICKNAME_MAX} characters`)
    .regex(NICKNAME_PATTERN, 'Letters, numbers, spaces, . _ - only');
/** The payload of POST /api/me/nickname. */
export const SetNicknameRequest = z.object({ nickname: NicknameSchema });
//# sourceMappingURL=profile.js.map